import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import categoryReducer from './slices/categorySlice';
import productReducer from './slices/productSlice';
import batchReducer from './slices/batchSlice';
import qrReducer from './slices/qrSlice';
import dispatchReducer from './slices/dispatchSlice';
import claimReducer from './slices/claimSlice';
import userReducer from './slices/userSlice';
import dashboardReducer from './slices/dashboardSlice';
import notificationReducer from './slices/notificationSlice';
import colorReducer from './slices/colorSlice';
import settingsReducer from './slices/settingsSlice';
import menuReducer from './slices/menuSlice';
import promotionReducer from './slices/promotionSlice';
import ownerReducer from './slices/ownerSlice';
import offerCodeReducer from './slices/offerCodeSlice';
import loyaltyReducer from './slices/loyaltySlice';
import scratchReducer from './slices/scratchSlice';
import luckyDrawReducer from './slices/luckyDrawSlice';
import registrationReducer from './slices/registrationSlice';
import subscriptionReducer from './slices/subscriptionSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    category: categoryReducer,
    product: productReducer,
    batch: batchReducer,
    qr: qrReducer,
    dispatch: dispatchReducer,
    claim: claimReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    notification: notificationReducer,
    color: colorReducer,
    settings: settingsReducer,
    menu: menuReducer,
    promotion: promotionReducer,
    owner: ownerReducer,
    offerCode: offerCodeReducer,
    loyalty: loyaltyReducer,
    scratch: scratchReducer,
    luckyDraw: luckyDrawReducer,
    registration: registrationReducer,
    subscription: subscriptionReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
});

export default store;
